import { MinusOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Input, InputNumber, Select, Typography } from "antd";
import { getProductSeries, getModelsBySeries } from "../utils/productData";
import { useState, useEffect } from "react";

const DisplayConfiguration = ({
  column,
  setColumn,
  row,
  setRow,
  unit,
  setUnit,
  selectedSeries,
  setSelectedSeries,
  availableModels,
  setAvailableModels,
  selectedModel,
  setSelectedModel,
  setSelectedModelData,
  selectedModelData,
  wallWidth,
  wallHeight,
  setWallWidth,
  setWallHeight,
}) => {
  // console.log("getProductSeries: ", getProductSeries()[0].models);

  useEffect(() => {
    if (selectedSeries) {
      const models = getModelsBySeries(selectedSeries);

      setAvailableModels(models);
      setSelectedModel(models[0].model); // Reset selected model when series changes
      setSelectedModelData(models[0]); // Reset selected model when series changes
    } else {
      setSelectedSeries(getProductSeries()[0].name);
    }
  }, [selectedSeries]);

  return (
    <>
      <div>
        <div style={{ display: "flex", gap: 10, width: "100%" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: selectedSeries ? "50%" : "100%",
            }}
          >
            <Typography
              style={{
                color: "#FFF",
                fontSize: 12,
                marginTop: 12,
                marginBottom: 5,
              }}
            >
              Select Product Series
            </Typography>
            <Select
              placeholder="Select Series"
              style={{ width: "100%" }}
              value={selectedSeries}
              onChange={(value) => setSelectedSeries(value)}
            >
              {getProductSeries().map((series) => (
                <Select.Option key={series.name} value={series.name}>
                  {series.name}
                </Select.Option>
              ))}
            </Select>
          </div>

          {selectedSeries && (
            <div
              style={{ display: "flex", flexDirection: "column", width: "50%" }}
            >
              <Typography
                style={{
                  color: "#FFF",
                  fontSize: 12,
                  marginTop: 12,
                  marginBottom: 5,
                }}
              >
                Select Model
              </Typography>
              <Select
                placeholder="Select Model"
                style={{ width: "100%" }}
                value={selectedModel}
                onChange={(value) => {
                  const result = availableModels.find(
                    (model) => model.model === value
                  );
                  setSelectedModelData(result);
                  setSelectedModel(result.model);
                  // if (unit === "feet") {
                  //   setWallWidth(5);
                  //   setWallHeight(5);
                  //   setColumn(1);
                  //   setRow(1);
                  // } else {
                  //   setWallWidth(1);
                  //   setWallHeight(1);
                  //   setColumn(1);
                  //   setRow(1);
                  // }
                }}
              >
                {availableModels.map((model) => (
                  <Select.Option key={model.model} value={model.model}>
                    {model.model}
                  </Select.Option>
                ))}
              </Select>
            </div>
          )}
        </div>

        {selectedSeries && selectedModelData !== null && (
          <div style={{ display: "flex", gap: 10, width: "100%" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
            >
              <Typography
                style={{
                  color: "#FFF",
                  fontSize: 12,
                  marginTop: 12,
                  marginBottom: 5,
                }}
              >
                Max Power Consumption
              </Typography>
              <Input
                value={`${selectedModelData.maxPowerConsumption[0].width}${selectedModelData.maxPowerConsumption[0].unit}`}
                readOnly
              />
            </div>
          </div>
        )}

        <div style={{ display: "flex", gap: 10 }}>
          <div>
            <Typography
              style={{
                color: "#FFF",
                fontSize: 12,
                marginTop: 12,
                marginBottom: 5,
              }}
            >
              Columns
            </Typography>
            <div
              style={{
                display: "flex",
                width: "100%",
                gap: 5,
              }}
            >
              <Button
                icon={<MinusOutlined style={{ color: "#fff" }} />}
                style={{
                  width: 35,
                  display: "flex",
                  alignItems: "center",
                  color: "#fff",
                }}
                onClick={() => {
                  if (column > 0) {
                    setColumn(column - 1);
                  }
                }}
                disabled={column === 1}
                variant="solid"
                color="default"
              />

              <Button
                icon={<PlusOutlined style={{ color: "#fff" }} />}
                style={{
                  width: 35,
                  display: "flex",
                  alignItems: "center",
                  color: "#fff",
                }}
                onClick={() => {
                  setColumn(column + 1);
                }}
                disabled={
                  selectedModelData !== null &&
                  (unit === "meter"
                    ? (column + 1) *
                        selectedModelData.panelDimensions.metric[0].width >
                      wallWidth * 1000
                    : (column + 1) *
                        selectedModelData.panelDimensions.imperial[0].width >
                      wallWidth * 12)
                }
                variant="solid"
                color="default"
              />

              <InputNumber
                style={{
                  width: "calc(100% - 80px)",
                  marginLeft: 5,
                }}
                min={1}
                max={9999999999}
                value={column}
                onChange={(value) => setColumn(value)}
              />
            </div>
            {selectedModelData !== null &&
              (unit === "meter"
                ? (column + 1) *
                    selectedModelData.panelDimensions.metric[0].width >
                  wallWidth * 1000
                : (column + 1) *
                    selectedModelData.panelDimensions.imperial[0].width >
                  wallWidth * 12) && (
                <div>
                  <Typography
                    style={{ color: "#9191c5", fontSize: 12, marginTop: 10 }}
                  >
                    Can't exceed wall width
                  </Typography>
                </div>
              )}
          </div>
          <div>
            <Typography
              style={{
                color: "#FFF",
                fontSize: 12,
                marginTop: 12,
                marginBottom: 5,
              }}
            >
              Rows
            </Typography>
            <div
              style={{
                display: "flex",
                width: "100%",
                gap: 5,
              }}
            >
              <Button
                icon={<MinusOutlined style={{ color: "#fff" }} />}
                style={{
                  width: 35,
                  display: "flex",
                  alignItems: "center",
                  color: "#fff",
                }}
                onClick={() => {
                  if (row > 0) {
                    setRow(row - 1);
                  }
                }}
                disabled={row === 1}
                variant="solid"
                color="default"
              />
              <Button
                icon={<PlusOutlined style={{ color: "#fff" }} />}
                style={{
                  width: 35,
                  display: "flex",
                  alignItems: "center",
                  color: "#fff",
                }}
                onClick={() => {
                  setRow(row + 1);
                }}
                disabled={
                  selectedModelData !== null &&
                  (unit === "meter"
                    ? (row + 1) *
                        selectedModelData.panelDimensions.metric[0].height >
                      wallHeight * 1000
                    : (row + 1) *
                        selectedModelData.panelDimensions.imperial[0].height >
                      wallHeight * 12)
                }
                variant="solid"
                color="default"
              />
              <InputNumber
                style={{ width: "calc(100% - 80px)", marginLeft: 5 }}
                min={1}
                max={9999999999}
                value={row}
                onChange={(value) => setRow(value)}
              />
            </div>
            {selectedModelData !== null &&
              (unit === "meter"
                ? (row + 1) *
                    selectedModelData.panelDimensions.metric[0].height >
                  wallHeight * 1000
                : (row + 1) *
                    selectedModelData.panelDimensions.imperial[0].height >
                  wallHeight * 12) && (
                <div>
                  <Typography
                    style={{ color: "#9191c5", fontSize: 12, marginTop: 10 }}
                  >
                    Can't exceed wall height
                  </Typography>
                </div>
              )}
          </div>
        </div>
      </div>
    </>
  );
};

export default DisplayConfiguration;
